/**
 * This handles landing page operations
 */
window._smpr = window._smpr || {};
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

window._smpr.dispenser_viewer = function () {

    let inFullScreenMode = false;
    let container, camera, controls, scene, renderer, loader, renderHeight = 280, bgScene, bgMesh;
    let modelLoading = true;
    let currentSelectedModel = null;
    let current3DModel = null;
    var init = function () {
        $(window).on("load", function () {
            setup3DScene();
        });

        $('.finish').on("click", function () {
            if (modelLoading) {
                return;
            }
            $('.finish .color').removeClass('selected');
            $(this).find('.color').addClass('selected');
            let url = $(this).data('fount-url');
            currentSelectedModel = $(this).data('model-id');
            loadDispenser(url);
        });

        $('.ar-finish').on("click", function () {
            $('.ar-finish .color').removeClass('selected');
            $(this).find('.color').addClass('selected');
            let modelID = $(this).data('model-id');
            $('#dispenser-ar').prop('src', 'https://devclever.8thwall.app/smart-pour?model=model' + modelID);
        });


        $('.choose-fount').on("click", function () {
            if (!currentSelectedModel) {
                currentSelectedModel = $('.finish').first().data('model-id');
            }
            if (fount_type == 'cola') {
                window.location = APP_URL + '/confirm-cola-fount/' + currentSelectedModel;
            } else {
                window.location = APP_URL + '/confirm-mixer-fount/' + currentSelectedModel;
            }
        });

        $('button[data-bs-toggle="pill"]').on('shown.bs.tab', function (e) {
            if (e.target.id == 'view-ar-tab') {
                //container.removeChild(renderer.domElement);
                //inFullScreenMode = true;
                //enableFullScreenMode();
                //$('#dispenser-ar').prop('src', 'https://devclever.8thwall.app/smart-pour?model=model' + fount_model_id);
                window.location.href = AR_URL;
            } else {
                if(inFullScreenMode){
                    setup3DScene();
                    inFullScreenMode = false;
                    disableFullScreenMode();
                }
                $('#dispenser-ar').prop('src', '');
            }
        });

        $('.full-screen').on("click", function () {
            inFullScreenMode = true;
            enableFullScreenMode();
        });

        $('.normal-screen').on("click", function () {
            inFullScreenMode = false;
            disableFullScreenMode();
        });

    };

    var enableFullScreenMode = function () {
        $('.gizmo').show();
        $('.full-screen').hide();
        $('.normal-screen').show();
        $('.main-nav').hide();
        $('#main-container').removeClass('container').addClass('container-fluid p-0');
        $('#fount-details-tab').addClass('full-screen-header');
        $('.title-section').hide();
        $('.3d-section').removeClass('col-md-4').addClass('col-md-12');
        $('.desc-section').hide();
        $('.controls').addClass('full-screen-controls');
        $('.controls .col-6:nth-child(1)').addClass('offset-md-4 col-md-2');
        $('.controls .col-6:nth-child(2)').addClass('col-md-2');
        $('.content').css('overflow', 'hidden');
        $('#canvas canvas').css("pointer-events", "auto");
        $('#canvas canvas').on('mousedown touchstart', function () {
            $('.gizmo').hide();
            $(this).off('mousedown touchstart');
        });
        controls.enabled = true;
        //controls.reset();
        renderHeight = window.innerHeight - 80;
        camera.aspect = window.innerWidth / renderHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, renderHeight);
    };

    var disableFullScreenMode = function () {
        $('.gizmo').hide();
        $('.normal-screen').hide();
        $('.full-screen').show();
        $('.main-nav').show();
        $('#main-container').removeClass('container-fluid p-0').addClass('container');
        $('#fount-details-tab').removeClass('full-screen-header');
        $('.title-section').show();
        $('.3d-section').removeClass('col-md-12').addClass('col-md-4');
        $('.desc-section').show();
        $('.controls').removeClass('full-screen-controls');
        $('.controls .col-6:nth-child(1)').removeClass('offset-md-4 col-md-2');
        $('.controls .col-6:nth-child(2)').removeClass('col-md-2');
        $('.content').css('overflow', 'visible');
        if (is_mobile == '1') {
            controls.enabled = false;
            $('#canvas canvas').css("pointer-events", "none");
        }
        //controls.reset();
        renderHeight = 280;
        camera.aspect = window.innerWidth / renderHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, renderHeight);
    };

    var setup3DScene = function () {

        init();
        //render(); // remove when using next line for animation loop (requestAnimationFrame)
        animate();

        function init() {
            THREE.Cache.enabled = true;
            container = document.getElementById('canvas');
            scene = new THREE.Scene();
            scene.background = new THREE.Color(0xf2cf9e);
            //scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
            renderer = new THREE.WebGLRenderer({ antialias: true });
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(window.innerWidth, renderHeight);
            container.appendChild(renderer.domElement);
            renderer.autoClearColor = false;
            renderer.outputEncoding = THREE.sRGBEncoding;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.toneMappingExposure = 1.2;
            renderer.gammaInput = true;
            renderer.gammaOutput = true;
            camera = new THREE.PerspectiveCamera(60, window.innerWidth / renderHeight, 1, 1000);
            camera.position.set(0, 0, 0);

            // lights
            const pointLight = new THREE.PointLight(0xffffff, 1);
            pointLight.position.set(0, 20, 40);
            scene.add(pointLight);

            const hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);
            hemiLight.position.set(0, 20, 0);
            scene.add(hemiLight);

            const dirLight = new THREE.DirectionalLight(0xffffff, 1.5);
            dirLight.position.set(- 3, 10, - 10);
            scene.add(dirLight);

            const ambientLight = new THREE.AmbientLight(0x222222);
            ambientLight.intensity = 1;
            scene.add(ambientLight);

            //environment map
            const textureLoader = new THREE.TextureLoader();
            const backgroundImage = textureLoader.load(APP_URL + '/models/images/env.jpg');
            backgroundImage.mapping = THREE.EquirectangularRefractionMapping;
            backgroundImage.encoding = THREE.sRGBEncoding;
            scene.environment = backgroundImage;
            // controls

            controls = new OrbitControls(camera, renderer.domElement);
            controls.listenToKeyEvents(window); // optional
            //controls.addEventListener( 'change', render ); // call this only in static scenes (i.e., if there is no animation loop)
            controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
            controls.dampingFactor = 0.05;
            controls.screenSpacePanning = false;
            controls.minDistance = 70;
            controls.maxDistance = 100;
            controls.maxPolarAngle = 1.39626;
            controls.minPolarAngle = 0.785398;
            //controls.minAzimuthAngle = -0.523599; // radians
            //controls.maxAzimuthAngle = 0.523599; // radians
            controls.target.set(0, 30, 0);
            //controls.reset();

            $('#canvas canvas').on('mousedown touchstart', function () {
                $('.gizmo').hide();
                $(this).off('mousedown touchstart');
            });
            if (is_mobile == '1') {
                $('#canvas canvas').css("pointer-events", "none");
                controls.enabled = false;
            } else {
                $('.gizmo').show();
                controls.enabled = true;
            }
            // world

            const dracoLoader = new DRACOLoader()
            dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.5/')

            // Instantiate a loader
            loader = new GLTFLoader();
            loader.setDRACOLoader(dracoLoader)

            modelLoading = true;
            $('.model-loading').show();
            // Load a glTF resource
            loader.load(
                // resource URL
                APP_URL + '/models/base.glb',
                // called when the resource is loaded
                function (gltf) {
                    gltf.scene.scale.set(0.1, 0.1, 0.1);
                    scene.add(gltf.scene);
                    //gltf.animations; // Array<THREE.AnimationClip>
                    //gltf.scene; // THREE.Group
                    //gltf.scenes; // Array<THREE.Group>
                    //gltf.cameras; // Array<THREE.Camera>
                    //gltf.asset; // Object

                },
                // called while loading is progressing
                function (xhr) {

                    console.log((xhr.loaded / xhr.total * 100) + '% loaded');

                },
                // called when loading has errors
                function (error) {

                    console.log('An error happened');

                }
            );

            loader.load(
                // resource URL
                fountModelURL,
                // called when the resource is loaded
                function (gltf) {
                    gltf.scene.scale.set(0.1, 0.1, 0.1);
                    scene.add(gltf.scene);
                    current3DModel = gltf.scene;
                    //gltf.animations; // Array<THREE.AnimationClip>
                    //gltf.scene; // THREE.Group
                    //gltf.scenes; // Array<THREE.Group>
                    //gltf.cameras; // Array<THREE.Camera>
                    //gltf.asset; // Object
                    modelLoading = false;
                    $('.model-loading').hide();
                    //$('.gizmo').show();
                },
                // called while loading is progressing
                function (xhr) {

                    console.log((xhr.loaded / xhr.total * 100) + '% loaded');

                },
                // called when loading has errors
                function (error) {
                    $('.model-loading').hide();
                    console.log('An error happened');

                }
            );



            //const geometry = new THREE.CylinderGeometry( 0, 10, 30, 4, 1 );
            //const material = new THREE.MeshPhongMaterial( { color: 0xffffff, flatShading: true } );

            //for ( let i = 0; i < 500; i ++ ) {

            //const mesh = new THREE.Mesh( geometry, material );
            //mesh.position.x = Math.random() * 1600 - 800;
            //mesh.position.y = 0;
            //mesh.position.z = Math.random() * 1600 - 800;
            //mesh.updateMatrix();
            //mesh.matrixAutoUpdate = false;
            //scene.add( mesh );

            //}

            bgScene = new THREE.Scene();
            bgMesh;
            {
                const loader = new THREE.TextureLoader();
                const texture = loader.load(
                    APP_URL + '/models/images/bar-scene.jpg',
                );
                texture.magFilter = THREE.LinearFilter;
                texture.minFilter = THREE.LinearFilter;

                const shader = THREE.ShaderLib.equirect;
                const material = new THREE.ShaderMaterial({
                    fragmentShader: shader.fragmentShader,
                    vertexShader: shader.vertexShader,
                    uniforms: shader.uniforms,
                    depthWrite: false,
                    side: THREE.BackSide,
                });

                material.uniforms.tEquirect.value = texture;
                const plane = new THREE.SphereBufferGeometry(20, 20, 20);
                bgMesh = new THREE.Mesh(plane, material);
                bgScene.add(bgMesh);
            }

            window.addEventListener('resize', onWindowResize);

        }

        function onWindowResize() {

            camera.aspect = window.innerWidth / renderHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, renderHeight);

        }

        function animate() {

            requestAnimationFrame(animate);
            controls.update(); // only required if controls.enableDamping = true, or if controls.autoRotate = true
            render();

        }

        function render() {
            bgMesh.position.copy(camera.position);
            renderer.render(bgScene, camera);
            renderer.render(scene, camera);
        }

    };

    var loadDispenser = function (url) {
        modelLoading = true;
        scene.remove(current3DModel);
        $('.model-loading').show();
        loader.load(
            // resource URL
            url,
            // called when the resource is loaded
            function (gltf) {
                gltf.scene.scale.set(0.1, 0.1, 0.1);
                scene.add(gltf.scene);
                //gltf.animations; // Array<THREE.AnimationClip>
                //gltf.scene; // THREE.Group
                //gltf.scenes; // Array<THREE.Group>
                //gltf.cameras; // Array<THREE.Camera>
                //gltf.asset; // Object
                modelLoading = false;
                current3DModel = gltf.scene;
                $('.model-loading').hide();
            },
            // called while loading is progressing
            function (xhr) {

                console.log((xhr.loaded / xhr.total * 100) + '% loaded');

            },
            // called when loading has errors
            function (error) {
                $('.model-loading').hide();
                console.log('An error happened');

            }
        );
    };

    var oPublic = {
        init: init
    };

    return oPublic;

}();

window._smpr.dispenser_viewer.init();
